<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2fm"><a id="page_4">INTRODUCTION</a></h2><a id="page_4">
<p class="center"><span class="txit">Trying to get a major project done but distracted by a growing list of smaller to-dos? Outsource.</span></p>
<p class="center"><span class="txit">Working from home but can’t stay focused? Take a quick shower to boost concentration.</span></p>
<p class="centerb"><span class="txit">Ready to disconnect from the office but still getting work messages at eight p.m.? Get a separate work number.</span></p>
<p class="noindentl"><span class="txit">Productivity Hacks</span> is packed with more than 500 simple productivity-boosting hacks just like these, and more than twenty hack lists to help you become a productivity pro—or at least a little better at warding off procrastination. Broken up into chapters based on your needs, you’ll find hacks on everything from productively working from home, to productive business travel, to holding office meetings that leave everyone energized and ready to work—instead of ready for a nap. You’ll also find great online resources and apps for making the most of your time.</p>
<p class="indentl">And productivity isn’t just for work! Your personal life also requires organization and care—things that can easily get lost in the shuffle of a hectic workweek. <span class="txit">Productivity Hacks</span> has a chapter on striking that delicate balance between your work life and home life, so you can leave the office <span class="txit">at</span> the office.</p>
</a><p class="indentl"><a id="page_4">With <span class="txit">Productivity Hacks</span>, there’s advice for every get-it-done-now situation, so you can read the section where you need the most help or flip to any page for a quick fix. Wherever you need to get things done, we’ve got you covered, so let’s start improving your productivity right now!</a><a id="page_5"></a></p><a id="page_5">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// intro.vue?011997b1